import Helper from './Helper';
import ShareHandler from './ShareHandler';
import SearchHandler from './SearchHandler';

class HeaderStateHandler {
  constructor() {
    this.serviceToggler = document.querySelector('#js-open-service-nav');
    this.serviceNav = document.querySelector('.header-nav__service');
    this.serviceOpen = false;
    if(this.serviceToggler){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.serviceToggler.addEventListener('click', () => {
      if(this.serviceOpen){
        this.closeServiceNav();
      } else{
        this.openServiceNav();
      }
    });
  }

  openServiceNav(){
    this.serviceNav.animate([
        // keyframes
        {
          width: '0px'
        },
        {
          width: '100%'
        }
      ], {
        // timing options
        duration: 400,
        iterations: 1
      });
      setTimeout(() => { Helper.addClass(this.serviceNav, 'open') }, 400);
      Helper.addClass(this.serviceToggler, 'open');
      this.serviceOpen = true;
    }

    closeServiceNav(){
      this.serviceNav.animate([
        // keyframes
        {
          width: '100%'
        },
        {
          width: '0px'
        }
      ], {
        // timing options
        duration: 400,
        iterations: 1
      });
    setTimeout(() => { Helper.removeClass(this.serviceNav, 'open') }, 400);
    Helper.removeClass(this.serviceToggler, 'open');
    this.serviceOpen = false;
  }

  static shareHandler(){
    if(SearchHandler.isSearchOpen()){
      SearchHandler.closeSearch();
    }
  }

  static searchHandler(){
    if(ShareHandler.isShareOpen()){
      ShareHandler.closeShare();
    }
  }



} export default HeaderStateHandler;
